import React from "react";
import { Navigate } from "react-router-dom";


const StockManagerProtectedRoute = ({ component: Component, ...rest }) => {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const is_Auth = userDetails?.accessToken;
    const is_StockManager = userDetails?.role === "stock_manager";

  return is_Auth && is_StockManager ? <Component {...rest} /> : <Navigate to="/" />;
};

export default StockManagerProtectedRoute;
